import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import { Link } from 'gatsby';
import _ from 'lodash';
import Img from 'gatsby-image';
import {
  PostCardWrapper,
  PostPreview,
  PostDetails,
  PostDate,
  PostTitle,
  Excerpt,
  PostContent,
  PostTags,
  PostDateAndPreview,
  ReadMore,
} from './postCardMinimal.style';

interface PostCardMinimalProps {
  image?: any;
  title: string;
  description?: string;
  url: string;
  date?: string;
  tags?: [];
  className?: string;
  imageType?: 'fixed' | 'fluid';
}

const PostCardMinimal: React.FunctionComponent<PostCardMinimalProps> = ({
  image,
  title,
  description,
  url,
  date,
  tags,
  className,
  imageType,
  ...props
}: PostCardMinimalProps) => {
  // Add all classs to an array
  const addAllClasses = ['post_card'];

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  return (
    <PostCardWrapper className={addAllClasses.join(' ')} {...props}>
      <PostDetails className="post_details">
        <PostDateAndPreview>
          {date && (
            <PostDate
              dangerouslySetInnerHTML={{
                __html: date,
              }}
              className="post_date"
            />
          )}
          {image == null ? null : (
            <PostPreview className="post_preview">
              <Link to={url}>
                {imageType === 'fluid' ? (
                  <Img fluid={image} alt="post preview" />
                ) : (
                  <Img fixed={image} alt="post preview" />
                )}
              </Link>
            </PostPreview>
          )}
        </PostDateAndPreview>

        <PostContent className="post_content">
          <PostTitle className="post_title">
            <Link to={url}>{title}</Link>
          </PostTitle>
          {description && (
            <Excerpt className="excerpt">
              <ReactMarkdown>{description}</ReactMarkdown>
            </Excerpt>
          )}
          <ReadMore>
            <Link to={url}>Read More</Link>
          </ReadMore>
          {tags == null ? null : (
            <PostTags className="post_tags">
              {tags
                .filter((tag: string) => tag !== 'all')
                .map((tag: string) => (
                  <Link key={tag} to={`/tags/${_.kebabCase(tag)}/`}>
                    {`#${tag}`}
                  </Link>
                ))}
            </PostTags>
          )}
        </PostContent>
      </PostDetails>
    </PostCardWrapper>
  );
};

PostCardMinimal.defaultProps = {
  imageType: 'fluid',
};

export default PostCardMinimal;
